import React from 'react'
import { Control, useController } from 'react-hook-form'

import { BankFormValues } from '@frame/components/screens/tasks/screens/strategies/bank/types'

import { Address } from './index'

type Props = {
  control: Control<BankFormValues>
  clearErrors: (key: string) => void
  disabled?: boolean
}

export function BankAddress({ clearErrors, disabled = false, control }: Props) {
  const { field, fieldState } = useController({
    name: 'address',
    control,
    rules: {
      validate: (value) => {
        if (!value?.place_id) {
          return 'Please select an address'
        }
        return true
      },
    },
  })

  return (
    <Address
      name={field.name}
      value={field.value}
      label="Home Address"
      noAddress={false}
      onChange={field.onChange}
      errors={fieldState.error?.message}
      clearErrors={clearErrors}
      disabled={disabled}
    />
  )
}
